module.exports = __webpack_public_path__ + "img/scan-logo.9a189e0d.jpg";